export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_USER_LOGIN = "/login";
export const ROUTE_USER_LOGOUT = "/logout";
